<section class="multi_step_form border border-success rounded">
    <form id="msform">
        <ul id="progressbar">
            <li [ngClass]="(lista.activa1)?'active':''" id="coordinacion">1 Datos Personales</li>
            <li [ngClass]="(lista.activa3)?'active':''" id="">2 Arancel de carrera</li>
            <li [ngClass]="(lista.activa4)?'active':''"id="analisis">3 Documentos Requeridos</li>
            <li [ngClass]="(lista.activa5)?'active':''" id="analisis">4 Firma de Contrato</li>
            <li [ngClass]="(lista.activa6)?'active':''" id="analisis">5 Pago</li>
            <li [ngClass]="(lista.activa7)?'active':''" id="analisis">6 Confirmación de Matricula</li>
        </ul>
    </form>
</section>
